module.exports = __webpack_public_path__ + "static/img/tri_r.500c15b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/tri_r.png
// module id = 645
// module chunks = 2